// apps/frontend/src/lib/sessionId.ts
// Identifiant de session anonyme persistant (uuid local), partagé entre
// behaviorTracking (page_view, product_click...) et useImpressionTracker.
//
// Pourquoi : on a besoin d'attacher TOUS les events frontend (même envoyés
// sans Bearer token) à la même "session" pour reconstituer un parcours
// visiteur anonyme côté admin live-users. Sans ça, chaque event apparaît
// isolé et on perd la séquence "vu page X → cliqué produit Y → reparti".
//
// Sécurité : pas de PII. Juste un uuid v4 local. Ne survit pas au clear
// browser data, on accepte cette perte (privacy-friendly).

const SESSION_KEY = 'glowp_session_id';

/**
 * Retourne le session_id courant (génère + persiste si absent).
 * Sûr en SSR (renvoie 'ssr' si window absent).
 */
export const getSessionId = (): string => {
  if (typeof window === 'undefined') return 'ssr';
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && 'randomUUID' in crypto
          ? crypto.randomUUID()
          : `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    // localStorage peut throw en mode strict (Safari private). Fallback
    // en mémoire — pas persistant entre refresh mais évite le crash.
    return `s_${Date.now()}`;
  }
};
